import { render } from "./BenchmarkExclusion.vue?vue&type=template&id=b10e0970"
import script from "./BenchmarkExclusion.vue?vue&type=script&lang=js"
export * from "./BenchmarkExclusion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__